<template>
  <van-pull-refresh
    v-model="refreshing"
    class="page-pull-refresh"
    @refresh="onRefresh"
  >
    <div class="data-statistics">
    <!--section class="stats-hero">
      <div class="stats-hero__copy">
        <span class="stats-hero__eyebrow">实时总览</span>
        <h2>南沙通道通行数据看板</h2>
        <p>将统计、设备与告警信息集中到同一层级，手机端便于扫读，桌面端便于并行查看。</p>
      </div>
      <div class="stats-hero__meta">
        <span class="meta-pill">系统登录 {{ statistics.loginCount || 0 }}</span>
        <span class="meta-pill meta-pill--soft">异常告警 {{ statistics.abnormalCount || 0 }}</span>
      </div>
    </section-->

    <div class="stats-toolbar">
      <div class="time-selector">
        <van-dropdown-menu>
          <van-dropdown-item v-model="selectedTimeRange" :options="timeRangeOptions" />
          <van-dropdown-item v-model="selectedDevice" :options="deviceOptions" />
        </van-dropdown-menu>
      </div>
      <!--van-button type="primary" size="small" class="refresh-btn" @click="refreshData" :loading="refreshLoading">
        {{ $tText('statistics.toolbar.refresh', '刷新数据') }}
      </van-button-->
    </div>

    <div class="stats-overview">
      <div class="stats-grid">
        <div class="stat-card boarding">
          <div class="stat-icon">
            <van-icon name="arrow-up" />
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ statistics.boardingCount }}</div>
            <div class="stat-label">{{ $tText('statistics.card.boarding', '登船人员') }}</div>
            <div class="stat-change positive">
              <van-icon name="arrow-up" />
              {{ statistics.boardingIncrease > 0 ? '+' : '' }}{{ statistics.boardingIncrease }}
            </div>
          </div>
        </div>

        <div class="stat-card disembarking">
          <div class="stat-icon">
            <van-icon name="arrow-down" />
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ statistics.disembarkingCount }}</div>
            <div class="stat-label">{{ $tText('statistics.card.disembarking', '离船人员') }}</div>
            <div class="stat-change negative">
              <van-icon name="arrow-down" />
              {{ statistics.disembarkingIncrease > 0 ? '+' : '' }}{{ statistics.disembarkingIncrease }}
            </div>
          </div>
        </div>

        <div class="stat-card sailor">
          <div class="stat-icon">
            <i class="icon icon-chuanyuan stat-icon" />
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ statistics.sailorCount }}</div>
            <div class="stat-label">{{ $tText('statistics.card.sailor', '船员数量') }}</div>
            <!--div class="stat-change" style="color:#7232dd;">
              船员数量
            </div-->
          </div>
        </div>
        
        <div class="stat-card permanent">
          <div class="stat-icon">
            <van-icon name="friends-o" />
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ statistics.permanentCount }}</div>
            <div class="stat-label">{{ $tText('statistics.card.permanent', '常备人员数量') }}</div>
            <!--div class="stat-change" style="color:#1989fa;">
              常备人员数量
            </div-->
          </div>
        </div>

        <div class="stat-card assistant">
          <div class="stat-icon">
            <van-icon name="manager-o" />
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ statistics.assistantCount }}</div>
            <div class="stat-label">{{ $tText('statistics.card.assistant', '协管员数量') }}</div>
            <!--div class="stat-change" style="color:#07c160;">
              协管员数量
            </div-->
          </div>
        </div>

        <div class="stat-card temporary">
          <div class="stat-icon">
            <van-icon name="user-o" />
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ statistics.temporaryCount }}</div>
            <div class="stat-label">{{ $tText('statistics.card.temporary', '临时人员数量') }}</div>
            <!--div class="stat-change" style="color:#ff976a;">
              临时人员数量
            </div-->
          </div>
        </div>        

        <div class="stat-card visitor">
          <div class="stat-icon">
            <van-icon name="contact" />
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ statistics.visitorCount }}</div>
            <div class="stat-label">{{ $tText('statistics.card.visitor', '访客数量') }}</div>
            <div class="stat-change" style="color:#7232dd;">
              <van-icon :name="statistics.guestIncrease >= 0 ? 'arrow-up' : 'arrow-down'" />
              {{ statistics.guestIncrease >= 0 ? '+' : '' }}{{ statistics.guestIncrease || 0 }}
            </div>
          </div>
        </div>

        <div class="stat-card current">
          <div class="stat-icon">
            <van-icon name="warning-o" />
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ statistics.abnormalCount }}</div>
            <div class="stat-label">{{ $tText('statistics.card.abnormal', '异常通行') }}</div>
            <div class="stat-change" style="color:#ff976a;">
              <van-icon :name="statistics.abnormalIncrease >= 0 ? 'arrow-up' : 'arrow-down'" />
              {{ statistics.abnormalIncrease >= 0 ? '+' : '' }}{{ statistics.abnormalIncrease || 0 }}
            </div>
          </div>
        </div>

        <div class="stat-card online-status">
          <div class="stat-icon">
            <van-icon name="cluster-o" />
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ statistics.loginCount || 0 }}</div>
            <div class="stat-label">{{ $tText('statistics.card.loginCount', '系统登录次数') }}</div>
            <div class="stat-change" style="color:#1989fa;">
              <van-icon :name="statistics.loginCountIncrease >= 0 ? 'arrow-up' : 'arrow-down'" />
              {{ statistics.loginCountIncrease >= 0 ? '+' : '' }}{{ statistics.loginCountIncrease || 0 }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="stats-content-grid">
      <div class="trend-chart">
        <div class="section-header">
          <div>
            <h3>{{ $tText('statistics.trend.title', '通行趋势') }}</h3>
            <p>{{ $tText('statistics.trend.subtitle', '按时间范围查看登船与离船走势') }}</p>
          </div>
          <van-button
            type="default"
            size="small"
            @click="toggleChartType"
          >
            {{ chartType === 'line' ? $tText('statistics.trend.switchToBar', '柱状图') : $tText('statistics.trend.switchToLine', '折线图') }}
          </van-button>
        </div>
        <div class="chart-container">
          <div ref="trendChart" style="width: 100%; height: 300px;"></div>
        </div>
      </div>

      <!--div class="stats-side-panel">
        <div class="quick-panel">
          <div class="section-header section-header--stack">
            <h3>{{ $tText('statistics.quick.title', '关键指标') }}</h3>
            <p>{{ $tText('statistics.quick.subtitle', '当前核心运行状态') }}</p>
          </div>
          <div class="quick-list">
            <div class="quick-item">
              <span>常备人员</span>
              <strong>{{ statistics.permanentCount || 0 }}</strong>
            </div>
            <div class="quick-item">
              <span>协管员</span>
              <strong>{{ statistics.assistantCount || 0 }}</strong>
            </div>
            <div class="quick-item">
              <span>临时人员</span>
              <strong>{{ statistics.temporaryCount || 0 }}</strong>
            </div>
            <div class="quick-item">
              <span>船员</span>
              <strong>{{ statistics.sailorCount || 0 }}</strong>
            </div>
            <div class="quick-item">
              <span>访客数量</span>
              <strong>{{ statistics.visitorCount || 0 }}</strong>
            </div>
            <div class="quick-item">
              <span>异常通行</span>
              <strong>{{ statistics.abnormalCount || 0 }}</strong>
            </div>
          </div>
        </div>

        <div class="quick-panel">
          <div class="section-header section-header--stack">
            <h3>界面优化说明</h3>
            <p>与 Figma 蓝色方案同步</p>
          </div>
          <ul class="insight-list">
            <li>顶部增加总览 Hero，先看状态再看数据。</li>
            <li>统计卡统一成蓝色信息卡，层级更稳定。</li>
            <li>桌面端使用左右分区，避免所有内容纵向堆叠。</li>
          </ul>
        </div>
      </div-->
    </div>
    </div>
  </van-pull-refresh>
</template>

<script>
import axios from '@/utils/request';
import * as echarts from 'echarts';
export default {
  name: 'StatisticsDashboard',
  data() {
    return {
      refreshing: false,
      selectedTimeRange: 0,
      selectedDevice: 0,
      deviceOptions: [{ text: '全部设备', value: 0 }],
      refreshLoading: false,
      chartType: 'line',
      timeRangeOptions: [
        { text: '今日', value: 0 },
        { text: '一周内', value: 1 },
        { text: '一月内', value: 2 },
        { text: '一年内', value: 3 }
      ],
      statistics: {
        boardingCount: 0,
        boardingIncrease: 0,
        disembarkingCount: 0,
        disembarkingIncrease: 0,
        permanentCount: 0,
        permanentChange: 0,
        currentOnBoard: 0,
        abnormalCount: 0, // 新增异常通行数量
        visitorCount: 0, // 新增访客数量
        loginCount: 0,
        loginCountIncrease: 0,
        assistantCount: 0, // 协管员数量
        temporaryCount: 0, // 临时人员数量
        sailorCount: 0 // 船员数量
      },
      // detailedStatistics 移除
      departmentStatistics: [],
      passTrend: [],
      trendChartInstance: null
    };
  },
  computed: {
    detailedStatistics() {
      return [
        {
          id: 1,
          title: '今日登船记录',
          description: '包含正常和异常登船记录',
          count: (this.statistics.boardingCount || 0) + '人次',
          icon: 'arrow-up',
          color: '#07c160',
          trend: { type: this.statistics.boardingIncrease >= 0 ? 'up' : 'down', text: (this.statistics.boardingIncrease >= 0 ? '+' : '') + this.statistics.boardingIncrease }
        },
        {
          id: 2,
          title: '今日离船记录',
          description: '包含正常和异常离船记录',
          count: (this.statistics.disembarkingCount || 0) + '人次',
          icon: 'arrow-down',
          color: '#ee0a24',
          trend: { type: this.statistics.disembarkingIncrease >= 0 ? 'up' : 'down', text: (this.statistics.disembarkingIncrease >= 0 ? '+' : '') + this.statistics.disembarkingIncrease }
        },
        {
          id: 3,
          title: '异常通行记录',
          description: '需要人工处理的异常记录',
          count: (this.statistics.abnormalCount || 0) + '人次',
          icon: 'warning-o',
          color: '#ff976a',
          trend: { type: this.statistics.abnormalIncrease >= 0 ? 'up' : 'down', text: (this.statistics.abnormalIncrease >= 0 ? '+' : '') + (this.statistics.abnormalIncrease || 0) }
        },
        {
          id: 4,
          title: '系统登录次数',
          description: '当前时间范围内的登录总次数',
          count: (this.statistics.loginCount || 0) + '次',
          icon: 'cluster-o',
          color: '#1989fa',
          trend: { type: this.statistics.loginCountIncrease >= 0 ? 'up' : 'down', text: (this.statistics.loginCountIncrease >= 0 ? '+' : '') + (this.statistics.loginCountIncrease || 0) }
        },
        {
          id: 5,
          title: '常备人员数量',
          description: '当前常备人员数量',
          count: (this.statistics.permanentCount || 0) + '人',
          icon: 'friends-o',
          color: '#7232dd'
        }
      ];
    }
  },
  mounted() {
    this.loadDevices();
    this.fetchStatistics();
    this.$nextTick(this.renderTrendChart);
  },
  methods: {
    loadDevices() {
      return axios.post('/api/Device/Query', {})
        .then(res => {
          if (res && res.data && res.data.success) {
            const devices = res.data.data || [];
            this.deviceOptions = [{ text: '全部设备', value: 0 }, ...devices.map(d => ({ text: d.deviceName, value: d.deviceName }))];
          } else {
            this.$toast.fail('获取设备列表失败');
          }
        })
        .catch(() => {
          this.$toast.fail('获取设备列表失败');
        });
    },
    async fetchStatistics() {
      const timeRangeMap = ['today', 'week', 'month', 'year'];
      const params = {
        timeRange: timeRangeMap[this.selectedTimeRange],
        bindingTK: this.selectedDevice === 0 ? '' : this.selectedDevice
      };
      try {
        const res = await axios.post('/api/DataStatistics/GetStatistics', params);
        if (res && res.data && res.data.success && res.data.data) {
          const d = res.data.data;
          this.statistics = {
            boardingCount: d.boardingCount,
            boardingIncrease: d.boardingIncrease,
            disembarkingCount: d.disembarkingCount,
            disembarkingIncrease: d.disembarkingIncrease,
            permanentCount: d.officerCount,
            permanentChange: 0,
            currentOnBoard: 0,
            abnormalCount: d.alarmCount,
            abnormalIncrease: d.alarmCountIncrease,
            visitorCount: d.guestCount,
            guestIncrease: d.guestCountIncrease,
            loginCount: d.loginCount,
            loginCountIncrease: d.loginCountIncrease,
            assistantCount: 0,
            temporaryCount: 0,
            sailorCount: 0
          };
          this.passTrend = d.passTrend || [];
          this.$nextTick(this.renderTrendChart);
        } else {
          this.$toast.fail('获取统计数据失败');
          return;
        }
      } catch {
        this.$toast.fail('获取统计数据失败');
        return;
      }

      // 通过 V1 接口查询人员数量（常备/协管员/临时）
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        const portCode = userInfo.portCode || '';
        if (portCode) {
          const v1Base = process.env.VUE_APP_V1_API_BASE_URL || 'https://www.weelook.com';
          const officerRes = await axios.get(v1Base + '/api/v1/OfficerInfo/getCount', {
            params: { portCode }
          });
          if (officerRes && officerRes.data && officerRes.data.success && officerRes.data.data) {
            const od = officerRes.data.data;
            this.statistics.permanentCount = od.permanentCount;
            this.statistics.assistantCount = od.assistantCount;
            this.statistics.temporaryCount = od.temporaryCount;
            this.statistics.sailorCount = od.sailorCount;
          }
        }
      } catch (e) {
        // 保留主接口返回的 officerCount 作为常备人员数量的兜底值
      }
    },
    async onRefresh() {
      try {
        await Promise.all([
          this.loadDevices(),
          this.fetchStatistics()
        ]);
      } finally {
        this.refreshing = false;
      }
    },
    refreshData() {
      this.refreshLoading = true;
      this.fetchStatistics();
      setTimeout(() => {
        this.$toast.success('数据已刷新');
        this.refreshLoading = false;
      }, 500);
    },
    
    viewDetails(item) {
      this.$toast(`查看${item.title}详情`);
    },
    
    getDepartmentTagType(status) {
      const typeMap = {
        '正常': 'success',
        '注意': 'warning',
        '异常': 'danger'
      };
      return typeMap[status] || 'default';
    },
    
    toggleChartType() {
      this.chartType = this.chartType === 'line' ? 'bar' : 'line';
    },
    
    getChartDataText() {
      const timeRange = this.timeRangeOptions[this.selectedTimeRange].text;
      return `${timeRange}通行数据趋势 (${this.chartType === 'line' ? '折线图' : '柱状图'})`;
    },
    renderTrendChart() {
      if (!this.$refs.trendChart) return;
      if (this.trendChartInstance) {
        this.trendChartInstance.dispose();
      }
      const chart = echarts.init(this.$refs.trendChart);
      const dates = (this.passTrend || []).map(item => item.date ? item.date.substr(0, 10) : '');
      const boarding = (this.passTrend || []).map(item => item.boarding || 0);
      const disembarking = (this.passTrend || []).map(item => item.disembarking || 0);
      const option = {
        color: ['#1677ff', '#78aafc'],
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(10, 31, 68, 0.92)',
          borderWidth: 0,
          textStyle: {
            color: '#fff'
          }
        },
        legend: {
          data: ['登船', '离船'],
          top: 0,
          textStyle: {
            color: '#5e6c87'
          }
        },
        grid: {
          left: 12,
          right: 12,
          top: 46,
          bottom: 10,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: dates,
          axisLine: {
            lineStyle: {
              color: '#cadefb'
            }
          },
          axisLabel: {
            color: '#6f7f97'
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: '人数',
          nameTextStyle: {
            color: '#6f7f97'
          },
          splitLine: {
            lineStyle: {
              color: '#e5eefc'
            }
          },
          axisLabel: {
            color: '#6f7f97'
          }
        },
        series: [
          {
            name: '登船',
            type: this.chartType,
            data: boarding,
            smooth: true,
            areaStyle: this.chartType === 'line' ? {
              color: 'rgba(22, 119, 255, 0.14)'
            } : undefined,
            barMaxWidth: 24
          },
          {
            name: '离船',
            type: this.chartType,
            data: disembarking,
            smooth: true,
            areaStyle: this.chartType === 'line' ? {
              color: 'rgba(120, 170, 252, 0.14)'
            } : undefined,
            barMaxWidth: 24
          }
        ]
      };
      chart.setOption(option);
      this.trendChartInstance = chart;
    }
  },
  
  watch: {
    selectedTimeRange() {
      this.$toast(`切换到${this.timeRangeOptions[this.selectedTimeRange].text}数据`);
      this.fetchStatistics();
    },
    selectedDevice() {
      const device = this.deviceOptions.find(d => d.value === this.selectedDevice);
      this.$toast(`切换到${device ? device.text : '未知设备'}数据`);
      this.fetchStatistics();
    },
    passTrend() {
      this.$nextTick(this.renderTrendChart);
    },
    chartType() {
      this.$nextTick(this.renderTrendChart);
    }
  },
  beforeDestroy() {
    if (this.trendChartInstance) {
      this.trendChartInstance.dispose();
    }
  }
};
</script>

<style scoped>
.data-statistics {
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-height: 100%;
}

.stats-hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 24px;
  border-radius: 28px;
  color: #fff;
  background: linear-gradient(135deg, var(--surface-strong) 0%, var(--brand-500) 65%, #6caeff 100%);
  box-shadow: 0 22px 50px rgba(15, 79, 185, 0.2);
}

.stats-hero__copy h2 {
  font-size: 28px;
  line-height: 1.18;
  margin-bottom: 10px;
}

.stats-hero__copy p {
  max-width: 680px;
  color: rgba(255, 255, 255, 0.82);
  line-height: 1.75;
}

.stats-hero__eyebrow {
  display: inline-flex;
  padding: 6px 10px;
  border-radius: 999px;
  margin-bottom: 12px;
  background: rgba(255, 255, 255, 0.14);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.stats-hero__meta {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}

.meta-pill {
  display: inline-flex;
  align-items: center;
  min-height: 42px;
  padding: 0 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  font-size: 13px;
  font-weight: 700;
}

.meta-pill--soft {
  background: rgba(255, 255, 255, 0.1);
}

.stats-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.time-selector {
  flex: 1;
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid var(--border-soft);
  border-radius: 22px;
  overflow: hidden;
  box-shadow: var(--shadow-card);
}

.refresh-btn {
  flex-shrink: 0;
  min-width: 104px;
}

.stats-overview {
  padding: 0;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.stat-card {
  background: rgba(255, 255, 255, 0.92);
  border-radius: 24px;
  padding: 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  border: 1px solid rgba(215, 229, 251, 0.96);
  box-shadow: var(--shadow-card);
}

.stat-card.boarding .stat-icon {
  background: linear-gradient(135deg, #0f5fd5, #1677ff);
}

.stat-card.disembarking .stat-icon {
  background: linear-gradient(135deg, #2f7ff4, #6caeff);
}

.stat-card.permanent .stat-icon {
  background: linear-gradient(135deg, #2068cf, #49a0ff);
}

.stat-card.current .stat-icon {
  background: linear-gradient(135deg, #f28a2b, #ffb04f);
}

.stat-card.online-status .stat-icon {
  background: linear-gradient(135deg, #0d8db1, #3eb8d8);
}

.stat-card.visitor .stat-icon {
  background: linear-gradient(135deg, #3a74d6, #6d9eff);
}

.stat-card.assistant .stat-icon {
  background: linear-gradient(135deg, #07c160, #34d97b);
}

.stat-card.temporary .stat-icon {
  background: linear-gradient(135deg, #ff6b35, #ff976a);
}

.stat-card.sailor .stat-icon {
  background: linear-gradient(135deg, #7232dd, #a67cff);
}

.stat-icon {
  width: 52px;
  height: 52px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
}

.stat-content {
  flex: 1;
}

.stat-number {
  font-size: 28px;
  font-weight: 800;
  color: var(--text-primary);
  line-height: 1;
}

.stat-label {
  font-size: 12px;
  color: var(--text-secondary);
  margin: 6px 0 4px;
}

.stat-change {
  font-size: 11px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 600;
}

.stat-change.positive {
  color: var(--success-500);
}

.stat-change.negative {
  color: var(--danger-500);
}

.stat-change.neutral {
  color: var(--text-muted);
}

.stats-content-grid {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(280px, 1fr);
  gap: 18px;
}

.trend-chart {
  background: rgba(255, 255, 255, 0.92);
  border-radius: 28px;
  border: 1px solid rgba(215, 229, 251, 0.96);
  box-shadow: var(--shadow-card);
  overflow: hidden;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding: 20px 22px 16px;
  border-bottom: 1px solid #ebf1fb;
}

.section-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
}

.section-header p {
  margin-top: 6px;
  color: var(--text-secondary);
  line-height: 1.6;
  font-size: 13px;
}

.section-header--stack {
  display: block;
  padding: 0 0 16px;
  border-bottom: 1px solid #ebf1fb;
}

.stats-side-panel {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.quick-panel {
  padding: 20px 22px;
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(215, 229, 251, 0.96);
  box-shadow: var(--shadow-card);
}

.quick-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.quick-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-radius: 18px;
  background: var(--surface-secondary);
  border: 1px solid var(--border-soft);
}

.quick-item span {
  color: var(--text-secondary);
  font-size: 13px;
}

.quick-item strong {
  color: var(--text-primary);
  font-size: 22px;
  line-height: 1;
}

.insight-list {
  margin: 0;
  padding-left: 18px;
  color: var(--text-secondary);
  line-height: 1.9;
  font-size: 13px;
}

.chart-container {
  padding: 18px 22px 22px;
}

@media (min-width: 1200px) {
  .stats-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .stats-content-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 1023px) {
  .stats-content-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 767px) {
  .data-statistics {
    gap: 14px;
  }

  .stats-hero {
    padding: 18px;
    border-radius: 24px;
    flex-direction: column;
  }

  .stats-hero__copy h2 {
    font-size: 22px;
  }

  .stats-hero__meta,
  .stats-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .stats-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
  }

  .stat-card {
    border-radius: 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    min-height: 142px;
    padding: 14px 12px;
  }

  .stat-icon {
    width: 42px;
    height: 42px;
    border-radius: 14px;
    font-size: 18px;
  }

  .stat-number {
    font-size: 22px;
  }

  .stat-label {
    font-size: 11px;
  }

  .stat-change {
    font-size: 10px;
  }

  .trend-chart,
  .quick-panel {
    border-radius: 22px;
  }

  .chart-container {
    padding: 14px;
  }
}
</style>
